<script setup>
    import IconDog from '../icons/IconDog.vue';
    import IconMaster from '../icons/IconMaster.vue';
    import IconHolding from '../icons/IconHolding.vue';

    defineEmits(['onChange']);
    defineProps({current: String})
</script>
<template>
  <div class="tab">
    <div
      class="item"
      :class="{dog: current == 'dog', active: current == 'dog'}"
      @click="$emit('onChange', 'dog')"
    >
      <IconDog :fill="current == 'dog' ? 'white' : null" />
      <span>Chien</span>
    </div>
    <div
      class="item"
      :class="{master: current == 'owner', active: current == 'owner'}"
      @click="$emit('onChange', 'owner')"
    >
      <IconMaster :fill="current == 'master' ? 'white' : null" />
      <span>Propriétaire / Maître</span>
    </div>
    <div
      class="item"
      :class="{holding: current == 'holding', active: current == 'holding'}"
      @click="$emit('onChange', 'holding')"
    >
      <IconHolding :fill="current == 'holding' ? 'white' : null" />
      <span>Exploitation</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../../assets/css/_variables.scss';

.tab {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background-color: white;
    border-bottom: 8px solid white;
    position: sticky;
    top: 0;
    z-index: 4;

  .item{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 5px 10px;
      background-color: var(--gray-200);
      border-radius: 15px;
      cursor: pointer;

      span{
          color: var(--gray-400);
          text-transform: uppercase;
          margin-left: 10px;
          font-size: 14px;
      }
  }

  .active{
      span{
          color: white;
      }
  }

  .dog{
    background-color: $censusDog;
  }

  .master{
      background-color: $censusMaster;
  }

  .holding{
      background-color: $censusHolding;
  }
}
</style>
